// Static copy for the public site. Services, team and hours come from the API so the owner can edit them.
export const site = {
  name: "Style & Curl",
  tagline: "Best Lil' Hair House in Texas",
  established: 1975,
  phone: "+19729243242",
  phoneDisplay: "(972) 924-3242",
  address: { line1: "119 W 4th St", city: "Anna", state: "TX", zip: "75409" },
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Style+%26+Curl+119+W+4th+St+Anna+TX+75409",
  mapsEmbed: "https://www.google.com/maps?q=119+W+4th+St,+Anna,+TX+75409&output=embed",
  facebookUrl: "https://www.facebook.com/StyleAndCurl/",
};

export const values = [
  {
    title: "Hometown",
    body: "Same corner of downtown Anna since 1975. We know your name, your kids' names, and how you like your part.",
  },
  {
    title: "Craft",
    body: "Precision cuts, classic sets, perms and color, done by stylists who take pride in every chair.",
  },
  {
    title: "Everyone",
    body: "Salon and barber under one roof, for women, men and kids. Bring the whole family.",
  },
];

export const faqs: { group: string; items: { q: string; a: string }[] }[] = [
  {
    group: "About the salon",
    items: [
      {
        q: "Where is Style & Curl?",
        a: "We're at 119 W 4th St in historic downtown Anna, Texas, a few steps from Main Street. Street parking is right out front.",
      },
      {
        q: "Are you a hair salon or a barber shop?",
        a: "Both. Style & Curl is a full-service salon and barber shop: women's cuts, color, perms and sets, plus men's cuts, beard trims and kids' cuts.",
      },
      {
        q: "How long have you been open?",
        a: "Since 1975. We're the longest-running salon in Anna, and owner Betty Noe has been behind the chair the whole way.",
      },
    ],
  },
  {
    group: "Booking",
    items: [
      {
        q: "Do I need an appointment?",
        a: "Appointments are recommended so you're not waiting. Book online in under a minute, or call us at (972) 924-3242. Walk-ins are welcome when there's an open chair.",
      },
      {
        q: "How do I change or cancel?",
        a: "Use the link in your confirmation text, or call the salon. Online changes are open until 2 hours before your appointment.",
      },
      {
        q: "Why do you text me a code?",
        a: "It confirms the phone number is yours, so your reminders reach you and nobody can book under your name.",
      },
    ],
  },
  {
    group: "Serving North Texas",
    items: [
      {
        q: "I live in Melissa or Van Alstyne. Is it worth the drive?",
        a: "Our regulars come from Melissa, Van Alstyne, Weston, Westminster and McKinney. It's a short drive up 75 to the friendliest chair in Collin County.",
      },
      {
        q: "Do you do hair for weddings and special events?",
        a: "Yes. Call the salon to plan updos and styling for brides, bridesmaids and the whole party.",
      },
    ],
  },
];
